module.exports = __webpack_public_path__ + "img/monnaie_pirate_logo.7a079566.png";